import { addToast } from '../components/CommonlyUsed/toastHelpers';
import { API_CLIENT_CONFIG } from '../constants';

/**
 * Centralized API URL configuration
 * Ensures production never uses localhost
 */

const isDevelopment = import.meta.env.MODE === 'development';
const isProduction = import.meta.env.MODE === 'production';

/**
 * Get the API base URL with proper fallbacks and production safety
 */
export const getApiBaseUrl = (): string => {
  // First priority: explicit VITE_API_BASE_URL
  if (import.meta.env.VITE_API_BASE_URL) {
    return import.meta.env.VITE_API_BASE_URL as string;
  }
  
  // Second priority: legacy VITE_API_URL
  if (import.meta.env.VITE_API_URL) {
    return import.meta.env.VITE_API_URL as string;
  }
  
  // Production without proper config - CRITICAL ERROR
  if (isProduction) {
    const errorMsg = '[CRITICAL] No API URL configured for production! Set VITE_API_BASE_URL in Railway environment variables.';
    // eslint-disable-next-line no-console -- Critical production configuration error
    console.error(errorMsg);

    // Show toast to make the issue immediately visible
    if (typeof window !== 'undefined') {
      addToast({
        message: `${errorMsg}\n\nThe application will not work properly without this configuration.`,
        type: 'error',
        duration: 10000, // Show for 10 seconds due to critical nature
      });
    }

    // Throw error to prevent silent failures
    throw new Error(errorMsg);
  }
  
  // Development environment - safe to use localhost
  if (isDevelopment) {
    return API_CLIENT_CONFIG.LOCALHOST_API_URL;
  }

  // Unknown environment - log warning but use localhost
  return API_CLIENT_CONFIG.LOCALHOST_API_URL;
};

// Export the configured API URL
export const API_BASE_URL = getApiBaseUrl();

// Log the final configuration
